import { useEffect, useRef } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { AppRoutes, AppRouting } from 'src/pages/app';
import { useAppSelector } from '../redux';

export const useGTM = () => {
  const location = useLocation();

  const prevLocationRef = useRef<string | null>(null);

  const { email, phoneNumber } = useAppSelector((store) => store.model.customer.data);

  useEffect(() => {
    const pagePath = location.pathname;

    window.dataLayer = window.dataLayer || [];

    const previousPage = prevLocationRef.current || null;

    // Pronalaženje odgovarajućeg pageName
    const findPageName = () => {
      for (const route of AppRouting) {
        const match = matchPath(route.path, location.pathname);
        if (match) {
          return route.pageName;
        }
      }
      return '';
    };

    const pageName = findPageName();

    window.dataLayer.push({
      event: 'virtualPageview',
      pageURL: pagePath,
      pageTitle: pageName,
      previousPage,
      trackingData: {
        category: 'Zdravstveno osiguranje'
      },
    });

    if (pagePath === AppRoutes.OFFERS.fullPath) {
      window.dataLayer.push({
        event: 'gtmt.priceCheck',
        trackingData: {
          category: 'Zdravstveno osiguranje',
          action: 'priceCheck',
          label: 'Dopunsko osiguranje',
          email,
          telephone: phoneNumber,
        },
      });
    }

    if (pagePath.includes(AppRoutes.CHECKOUT_PAYMENT_SENT.fullPath)) {
      window.dataLayer.push({
        event: 'DZO_UplatnicaJednokratno'
      });
    }

    if (pagePath.includes(AppRoutes.CHECKOUT_PAYMENT_SENT_INSTALLMENTS.fullPath)) {
      window.dataLayer.push({
        event: 'DZO_UplatnicaNaRate'
      });
    }

    // Update the previous page reference
    prevLocationRef.current = pagePath;
  }, [location]);
};
